// extracted by mini-css-extract-plugin
export default {"slotHighlighted":"c5FRQj"};